import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axios';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import M from 'materialize-css';
import { UserContext } from '../../UserContext';
import { checkPermiso } from '../../Utils/PermissionsFunctions';
import NoPermissions from '../NoPermissions/NoPermissions';
import Loader from '../../Layout/Loaders/Loader';
import { Switch } from '@headlessui/react';
import SucursalSelector from './SucursalSelector';

const Edit = () => {
    let {productoId} = useParams();
    const {user} = useContext(UserContext);
    const [servicio, setServicio] = useState({nombre_producto:"", precio_unidad:"", duracion_aproximada:"", descripcion:"", activo:"",visible_web:false,solo_presencial:false});
    // Estado para sucursales asignadas y disponibles
    const [sucursalesAsignadas, setSucursalesAsignadas] = useState([]);
    const [sucursalesDisponibles, setSucursalesDisponibles] = useState([]);
    const navigate = useNavigate();
    const [loaded,setLoaded] = useState(false);
    const [permisos,setPermisos] = useState({
        products_read:null,
        products_update:null
    });
    const [validate,setValidate] = useState({nombre_producto:true, precio_unidad:true});

    useEffect (() =>{
        if(user.id){
            setPermisos((prevPremisos) => ({
                ...prevPremisos,
                products_read:checkPermiso("products_read",user.permissions),
                products_update:checkPermiso("products_update",user.permissions)
            }));
        }
    },[user]);

    useEffect(()=>{
        if(permisos.products_read !== null){
             setLoaded(true);
            _getProducto();
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[permisos]);

    const _getProducto = () =>{
        axios.get(`api/products/${productoId}`)
        .then(res=>{
            console.log('producto',res.data);
            // Establecer valores por defecto de 0 para campos que puedan venir como null
            const productoData = {
                ...res.data,
                duracion_aproximada: res.data.duracion_aproximada ?? 0,
                dias_entrega: res.data.dias_entrega ?? 0,
                dias_preparacion: res.data.dias_preparacion ?? 0
            };
            setServicio(productoData);
            // Si el producto ya tiene sucursales asignadas, setéalas
            if (res.data.sucursals) setSucursalesAsignadas(res.data.sucursals);
        }).catch(e =>{console.log(e, 'Error ')})
    }
    // Cargar sucursales disponibles
    useEffect(() => {
        axios.get('api/sucursals')
          .then(res => setSucursalesDisponibles(res.data))
          .catch(e => M.toast({ html: '<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Error al cargar sucursales</span>', classes: "error-notify" }));
    }, []);
    
    const _editProducto = (e) =>{
        e.preventDefault();
        console.log("Update...",servicio);
       if(permisos.products_update === null){
            M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>No tienes permisos para editar este producto/servicio</span>',classes:"error-notify"})   
            return;
        }
        // Incluye sucursalesAsignadas en el payload
        axios.put(`api/products/${productoId}`, { ...servicio, sucursales: sucursalesAsignadas }).then(resp=>{
            console.log(resp.data)
            M.toast({
                html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Producto/Servicio actualizado exitosamente</span>',
                classes:"success-notify"
            })
            setTimeout(() => {
                navigate("/admin/servicios")
            }, 3000);
        }).catch(e=>{
            console.log(e);
            if(e.response?.data?.errors){
                let errors = e.response.data.errors;
                setValidate({
                    products_read:(errors.products_read)? false:true, 
                    products_update:(errors.products_update)? false:true
                })
                if(errors.products_read) {
                    M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span> Falta products read </span>',classes:"error-notify"})
                }
                if(errors.products_update) {
                    M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span> Falta products update </span>',classes:"error-notify"})
                }
            }
        });
    }

    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb actual={servicio.nombre_sucursal} />
            </div>
            <div className="container-admin-container">
                <div className="container-admin bg-white rounded-lg shadow-md">
                    <h5 className="p-5 text-xl font-bold flex items-center justify-start">Editar Servicios/Productos</h5>
                    {loaded ? (
                        permisos.products_read ? (
                            <form onSubmit={_editProducto} className="grid grid-cols-12 gap-4 px-5 pb-5" id="general-form">
                                {/* Nombre */}
                                <div className="col-span-12 md:col-span-6">
                                    <div className="flex flex-col gap-1">
                                        <label htmlFor="name" className="text-sm font-medium text-gray-600">Nombre del Servicio *</label>
                                        <input
                                            id="name"
                                            type="text"
                                            className="dento-input"
                                            value={servicio.nombre_producto}
                                            onChange={(e) => setServicio({ ...servicio, nombre_producto: e.target.value })}
                                        />
                                        {!validate.nombre_producto && (
                                            <span className="text-sm text-red-500">El nombre del servicio es obligatorio.</span>
                                        )}
                                    </div>
                                </div>
                                {/* Precio unidad */}
                                <div className="col-span-12 md:col-span-6">
                                    <div className="flex flex-col gap-1">
                                        <label htmlFor="precio" className="text-sm font-medium text-gray-600">Precio unidad *</label>
                                        <input
                                            id="precio"
                                            type="number"
                                            step="0.01"
                                            className="dento-input"
                                            value={servicio.precio_unidad}
                                            onChange={(e) => setServicio({ ...servicio, precio_unidad: e.target.value })}
                                        />
                                        {!validate.precio_unidad && (
                                            <span className="text-sm text-red-500">El precio es obligatorio.</span>
                                        )}
                                    </div>
                                </div>
                                {/* Duración aproximada */}
                                <div className="col-span-12 md:col-span-4">
                                    <div className="flex flex-col gap-1">
                                        <label htmlFor="horario" className="text-sm font-medium text-gray-600">Duración (min) *</label>
                                        <input
                                            id="horario"
                                            type="number"
                                            step="any"
                                            min="0"
                                            className="dento-input"
                                            value={servicio.duracion_aproximada}
                                            onChange={(e) => setServicio({ ...servicio, duracion_aproximada: e.target.value })}
                                        />
                                    </div>
                                </div>
                                {/* Días de entrega */}
                                <div className="col-span-12 md:col-span-4">
                                    <div className="flex flex-col gap-1">
                                        <label htmlFor="entrega" className="text-sm font-medium text-gray-600">Días de entrega</label>
                                        <input
                                            id="entrega"
                                            type="number"
                                            min="0"
                                            className="dento-input"
                                            value={servicio.dias_entrega}
                                            onChange={(e) => setServicio({ ...servicio, dias_entrega: e.target.value })}
                                        />
                                    </div>
                                </div>
                                {/* Días de preparación */}
                                <div className="col-span-12 md:col-span-4">
                                    <div className="flex flex-col gap-1">
                                        <label htmlFor="preparacion" className="text-sm font-medium text-gray-600">Días de preparación</label>
                                        <input
                                            id="preparacion"
                                            type="number"
                                            step="any"
                                            min="0"
                                            className="dento-input"
                                            value={servicio.dias_preparacion}
                                            onChange={(e) => setServicio({ ...servicio, dias_preparacion: e.target.value })}
                                        />
                                    </div>
                                </div>
                                {/* Descripción */}
                                <div className="col-span-12">
                                    <div className="flex flex-col gap-1">
                                        <label htmlFor="description" className="text-sm font-medium text-gray-600">Descripción Corta (Web Agenda)</label>
                                        <textarea
                                            id="description"
                                            className="dento-input min-h-24 resize-vertical"
                                            value={servicio.descripcion}
                                            onChange={(e) => setServicio({ ...servicio, descripcion: e.target.value })}
                                        />
                                    </div>
                                </div>
                                {/* Estado del servicio (Switch) */}
                                <div className="col-span-12 md:col-span-4 flex items-center">
                                    <div className="flex flex-col gap-1 w-full">
                                        <label htmlFor="activo" className="text-sm font-medium text-gray-600">Estado del servicio</label>
                                        <Switch
                                            checked={!!servicio.activo}
                                            onChange={v => setServicio({ ...servicio, activo: v })}
                                            className={`${servicio.activo ? 'bg-blue-600' : 'bg-gray-300'} relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                                        >
                                            <span className="sr-only">Activo</span>
                                            <span
                                                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${servicio.activo ? 'translate-x-6' : 'translate-x-1'}`}
                                            />
                                        </Switch>
                                        <span className="text-xs text-gray-500 mt-1">{servicio.activo ? 'Activo' : 'Inactivo'}</span>
                                    </div>
                                </div>
                                    {/* Visible en web (Switch) */}
                                <div className="col-span-12 md:col-span-4 flex items-center">
                                    <div className="flex flex-col gap-1 w-full">
                                        <label htmlFor="visible_web" className="text-sm font-medium text-gray-600">Visible en Web</label>       
                                        <Switch
                                            checked={!!servicio.visible_web}
                                            onChange={v => setServicio({ ...servicio, visible_web: v })}
                                            className={`${servicio.visible_web ? 'bg-blue-600' : 'bg-gray-300'} relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                                        >
                                            <span className="sr-only">Visible en Web</span> 
                                            <span
                                                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${servicio.visible_web ? 'translate-x-6' : 'translate-x-1'}`}
                                            />  
                                        </Switch>
                                        <span className="text-xs text-gray-500 mt-1">{servicio.visible_web ? 'Sí' : 'No'}</span>
                                    </div>
                                </div>  
                                {/* Solo presencial - no requiere cita (Switch) */}
                                <div className="col-span-12 md:col-span-4 flex items-center">
                                    <div className="flex flex-col gap-1 w-full">
                                        <label htmlFor="solo_presencial" className="text-sm font-medium text-gray-600">Solo presencial</label>
                                        <Switch
                                            checked={parseInt(servicio.solo_presencial) === 1}
                                            onChange={v => setServicio({ ...servicio, solo_presencial: v ? 1 : 0 })}
                                            className={`${ parseInt(servicio.solo_presencial) === 1 ? 'bg-orange-500' : 'bg-gray-300'} relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2`}
                                        >
                                            <span className="sr-only">Solo presencial</span>
                                            <span
                                                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${parseInt(servicio.solo_presencial) === 1 ? 'translate-x-6' : 'translate-x-1'}`}
                                            />
                                        </Switch>
                                        <span className="text-xs text-gray-500 mt-1">{parseInt(servicio.solo_presencial) === 1 ? 'No requiere cita' : 'Requiere cita'}</span>
                                    </div>
                                </div>
                                {/* Sucursales asignadas */}
                                <div className="col-span-12">
                                    <SucursalSelector
                                        sucursalesDisponibles={sucursalesDisponibles}
                                        sucursalesAsignadas={sucursalesAsignadas}
                                        onChange={setSucursalesAsignadas}
                                    />
                                </div>
                                {/* Botón guardar */}
                                <div className="col-span-12 pt-6 flex justify-end">
                                    <button
                                        className="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white hover:bg-blue-700 font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                        type="submit"
                                    >
                                        Actualizar datos
                                        <span className="material-icons">save</span>
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <NoPermissions />
                        )
                    ) : (
                        <Loader />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Edit;